import { Header, HeaderText } from '@sdk/components/ui/modal/components/modalHeader.styles';
import CloseIcon from '@sdk/components/ui/CloseIcon';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { useTheme } from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

import ShiftTaskIcon from '@web/assets/svg/Icons/32/shift-blue.svg';

import { NextTaskButton, PreviousTaskButton, Spacer } from './shiftTaskNotificationHeader.styles';

type Props = {
  title: string;
  onClose: () => void;
  currentIndex: number;
  goToNextItem: VoidFunction;
  goToPreviousItem: VoidFunction;
  itemsCount: number;
};

export const ShiftTaskNotificationHeader = ({
  title,
  onClose,
  currentIndex,
  itemsCount,
  goToNextItem,
  goToPreviousItem,
}: Props) => {
  const theme = useTheme();

  const previousButton =
    currentIndex !== 0 ? <PreviousTaskButton onClick={goToPreviousItem} /> : <Spacer />;

  const nextButton =
    currentIndex !== itemsCount - 1 ? <NextTaskButton onClick={goToNextItem} /> : <Spacer />;

  return (
    <Header>
      <Row alignItems="center" gap={12}>
        <ShiftTaskIcon aria-hidden={true} />
        <HeaderText themeColor={ThemeColorType.primary} semiBold>
          {title}
        </HeaderText>
      </Row>

      <Row alignItems="center">
        {itemsCount > 1 && (
          <>
            {previousButton}
            <Text14 themeColor={ThemeColorType.gray}>
              {currentIndex + 1} {' / '} {itemsCount}
            </Text14>
            {nextButton}
          </>
        )}

        <CloseIcon spacing={10} onClick={onClose} color={theme.colors.iconGray} />
      </Row>
    </Header>
  );
};
